module.exports = __webpack_public_path__ + "images/apply-angel.2d1bbdfd.png";